import {
  Box,
  Button,
  CircularProgress,
  IconButton,
  InputAdornment,
  OutlinedInput,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import logoimg from "../../Utils/Logos/mindfulnesslogo.PNG";
import { Link, useNavigate } from "react-router-dom";
import * as yup from "yup";
import axios from "axios";
import Swal from "sweetalert2";
import { Baseurl } from "../../Apis/Api";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { ToastContainer, toast } from "react-toastify";
const Login = () => {
  let [loading, setloading] = useState(false);
  const [errors, setErrors] = useState({});
  const validationSchema = yup.object().shape({
    email: yup.string().email("Invalid email").required("Email is required"),
    password: yup.string().required("Password is required"),
  });
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  let navigate = useNavigate();

  let NavigatetoDashboard = () => {
    validationSchema
      .validate(formData, { abortEarly: false })
      .then(async () => {
        setloading(true);
        try {
          let data = await axios.post(`${Baseurl}/auth/admin_login`, {
            ...formData,
          });
          if (data.data) {
            if (data.data.s == 0) {
              toast.error(data?.data?.m, {
                position: "top-center",
                autoClose: 1200,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
              });
            } else if (data.data.s == 1) {
              localStorage.setItem("m_authdata", JSON.stringify(data?.data?.r));
              toast.success("Login Success !", {
                position: "top-center",
                autoClose: 1200,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
              });
              setTimeout(() => {
         
                navigate("/dashboard");
              }, 1500);
              setTimeout(() => {
                window.location.reload()
              }, 1500);
            } else {
              toast.error("Something wents wrong !", {
                position: "top-center",
                autoClose: 1200,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
              });
            }
            setloading(false);
          }
        } catch (error) {
          setloading(false);
        }
        setErrors("");
      })
      .catch((err) => {
        const validationErrors = {};

        err.inner.forEach((error) => {
          validationErrors[error.path] = error.message;
        });

        setErrors(validationErrors);
      });
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });
  };
  const [showPassword, setShowPassword] = useState(false);
  const handleTogglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={1200}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <Box
        sx={{
          background:
            "linear-gradient(180deg, #EFBABD 0%, #D0D1D2 48.42%, #B6E4E4 100%);",
          height: "100vh",
          width: "100vw",
          display: "flex",
          fontFamily: "Poppins",
        }}
      >
        <Box
          sx={{
            padding: "50px",
            background: "rgba(255, 255, 255, 0.50)",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            color: "#000",
            borderRadius: "30px",
            width: "40%",
            boxSizing: "border-box",
            m: "auto",
          }}
        >
          <Box
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              gap: "15px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                fontFamily: "Poppins",
                gap: "10px",
              }}
            >
              <Box sx={{ width: "200px", height: "200px" }}>
                <img
                  src={logoimg}
                  style={{ width: "100%", height: "100%" }}
                  alt="logoimg"
                />
              </Box>
              <Typography
                sx={{
                  fontFamily: "Poppins",
                  fontSize: "35px",
                  fontWeight: "700",
                }}
              >
                Admin Login
              </Typography>
              <Typography
                sx={{
                  fontFamily: "Poppins",
                  fontSize: "18px",
                  fontWeight: "500",
                }}
              >
                Please Enter your Email & Password to Login
              </Typography>
            </Box>

            <Box
              sx={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                gap: "15px",
              }}
            >
              <Box>
                <OutlinedInput
                  id={"vhgbftbnfkgsvf"}
                  name="email"
                  aria-describedby="outlined-weight-helper-text"
                  placeholder={"Email"}
                  value={formData.email}
                  onChange={handleInputChange}
                  sx={{
                    width: "100%",
                    color: "black",
                    fontSize: "20px",
                    borderRadius: "8px",
                    fontFamily: "Montserrat",
                    borderColor: "  #DADADA",
                    outline: "none",

                    "& .MuiFilledInput-root": {
                      background: "var(--white-100, #FFF)",
                      outline: "none",
                    },
                    "& fieldset": { border: "none" },
                    width: "100%",
                    "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button":
                      {
                        display: "none",
                      },
                    "& .MuiInputBase-input": {
                      color: "black",
                      fontSize: { xs: "13px", md: "16px" },
                      fontWeight: 400,
                      lineHeight: "24px",
                      border: "2px solid var(--Button-Color, #F68582)",
                      padding: "10px 10px",
                      background: "var(--white-100, #FFF)",
                      outline: "none",
                      borderRadius: "10px",

                      "&::placeholder": {
                        color: "rgba(41, 45, 50, 0.50)",
                        background: "var(--white-100, #FFF)",
                        opacity: 0.5,
                        fontSize: { xs: "13px", md: "16px" },
                        fontWeight: 400,
                        lineHeight: "10px",
                        outline: "none",
                        outline: "none",
                        // background: "var(--white-100, #FFF)",
                        border: "none",
                      },
                    },
                    "&:hover": {
                      "& fieldset": {
                        outline: "none",
                        // background: "var(--white-100, #FFF)",
                        border: "none",
                      },
                      "& .MuiInputBase-input": {
                        color: "black", // Change the color to black on hover
                      },
                    },
                    "&:focus": {
                      outline: "none",
                      boxShadow: "none",
                      color: "rgba(41, 45, 50, 0.50)",
                    },
                    "&.Mui-focused fieldset": {
                      outline: "none",
                      border: "solid red",
                    },
                  }}
                  inputProps={{ autoComplete: "off" }}
                />

                {errors.email && (
                  <Typography sx={{ color: "red", fontSize: "12px" }}>
                    {errors.email}
                  </Typography>
                )}
              </Box>
              <Box>
                <OutlinedInput
                  id={"vhkgsvf"}
                  name="password"
                  aria-describedby="outlined-weight-helper-text"
                  placeholder={"Password"}
                  type={showPassword ? "text" : "password"}
                  value={formData.password}
                  onChange={handleInputChange}
                  endAdornment={
                    <InputAdornment sx={{ background: "#fff" }} position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleTogglePasswordVisibility}
                        edge="end"
                      >
                        {showPassword ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  }
                  sx={{
                    width: "100%",
                    color: "black",
                    background: "#fff",
                    fontSize: "20px",
                    borderRadius: "8px",
                    border: "2px solid var(--Button-Color, #F68582)",
                    fontFamily: "Montserrat",
                    // borderColor: "  #DADADA",
                    outline: "none",
                    "& .MuiFilledInput-root": {
                      background: "var(--white-100, #FFF)",
                      outline: "none",
                    },
                    "&:hover": {
                      "& fieldset": {
                        outline: "none",
                        // background: "var(--white-100, #FFF)",
                        border: "none",
                      },
                      "& .MuiInputBase-input": {
                        color: "black", // Change the color to black on hover
                      },
                    },
                    "& fieldset": { border: "none" },
                    width: "100%",
                    "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button":
                      {
                        display: "none",
                      },
                    "& .MuiInputBase-input": {
                      color: "black",
                      fontSize: { xs: "13px", md: "16px" },
                      fontWeight: 400,
                      // border: "2px solid var(--Button-Color, #F68582)",
                      lineHeight: "24px",
                      padding: "10px 10px",
                      background: "var(--white-100, #FFF)",
                      outline: "none",
                      borderRadius: "10px",
                      "&::placeholder": {
                        color: "rgba(41, 45, 50, 0.50)",
                        background: "var(--white-100, #FFF)",
                        opacity: 0.5,
                        fontSize: { xs: "13px", md: "16px" },
                        fontWeight: 400,
                        lineHeight: "10px",
                        outline: "none",
                      },
                    },
                    "&:focus": {
                      outline: "none",
                      boxShadow: "none",
                      border: "2px solid var(--Button-Color, #F68582)",
                      color: "rgba(41, 45, 50, 0.50)",
                    },
                    "&.Mui-focused fieldset": {
                      //   borderColor: "#FFFF",
                      outline: "none",
                    },
                  }}
                  inputProps={{ autoComplete: "off" }}
                />

                {errors.password && (
                  <Typography sx={{ color: "red", fontSize: "12px" }}>
                    {errors.password}
                  </Typography>
                )}
              </Box>
              <Link
                style={{ textDecoration: "none", color: "#000" }}
                to={"/forgotpassword"}
              >
                <Typography
                  sx={{
                    fontSize: "16px",
                    fontWeight: "600",
                    fontFamily: "Poppins",
                    // mb: "5px",
                    textAlign: "right",
                  }}
                >
                  Forgot Password?
                </Typography>
              </Link>
            </Box>

            <Button
              onClick={NavigatetoDashboard}
              sx={{
                background: "linear-gradient(180deg, #FFCE98 0%, #F4AA50 100%)",
                textTransform: "capitalize",
                color: "#292D32",
                width: "100%",
                padding: "15px",
                height: "55px",
                fontFamily: "Montserrat",
                borderRadius: "15px",
                boxShadow:
                  " 2px 2px 8px 0px rgba(143, 95, 11, 0.50), 0px 3px 11.111px 0px #FBB15A inset, 0px -11px 11.111px 0px #D68835 inset;",
                "&:hover": {
                  backgroundColor: "#252422", // Change the background color on hover
                },
              }}
            >
              {loading ? (
                <CircularProgress sx={{ color: "#fff" }} />
              ) : (
                <Typography>Log In</Typography>
              )}
            </Button>
          </Box>
        </Box>
      </Box>
      {/* </Box>    */}
    </>
  );
};

export default Login;
